import { Button, Modal } from "flowbite-react";
import React, { useEffect } from "react";
import { ButtonColor } from "../../common/enum/button-color";
import { ItemAdminOrderType } from "../../common/enum/item-admin-order-type";
import { ItemType } from "../../common/enum/item-type";
import { itemService } from "../../services/item-service";
import { BasePageDto } from "../../types/dto/base-page-dto";
import { ItemDetailDto } from "../../types/dto/item-detail-dto";
import { ChildItemCategoryFilter } from "../filter/ChildItemCategoryFilter";
import { BlackArrowNarrowRightlineIcon } from "../icon/BlackArrowNarrowRightIcon";
import { GrayArrowNarrowRightlineIcon } from "../icon/GrayArrowNarrowRightIcon";
import { PackageItemChildSelectedTable } from "../table/package-item-child-select-table/PackageItemChildSelectTable";
import { PackageItemChildSelectTable } from "../table/package-item-child-selected-table/PackageItemChildSelectTable";
import { Body16Regular } from "../typography/Body16Regular";
import { H4 } from "../typography/H4";

interface Props {
  childDetailItems: ItemDetailDto[];
  setChildItems: (items: ItemDetailDto[]) => void;
  closeModal: () => void;
}

export const PackageChildItemModal: React.FC<Props> = ({
  childDetailItems,
  setChildItems,
  closeModal,
}) => {
  const [itemPage, setItemPage] = React.useState<BasePageDto<ItemDetailDto>>({
    contents: [],
    currentPage: 0,
    totalElements: 0,
    totalPage: 0,
    isFirst: true,
    isLast: false,
  });

  const [checkedItems, setCheckedItems] = React.useState<ItemDetailDto[]>([]);
  const [selectedItems, setSelectedItems] =
    React.useState<ItemDetailDto[]>(childDetailItems);

  const [categoryIds, setCategoryIds] = React.useState<number[]>([]);

  const addCheckedItem = (id: number) => {
    const item = itemPage.contents.find((item) => item.id === id);
    if (!item) {
      return;
    }
    setCheckedItems([...checkedItems, item]);
  };

  const removeCheckedItem = (id: number) => {
    setCheckedItems(checkedItems.filter((item) => item.id !== id));
  };

  const addSelectedItem = () => {
    setSelectedItems([...selectedItems, ...checkedItems]);
    setCheckedItems([]);
  };

  const removeSelectedItem = (id: number) => {
    setSelectedItems(selectedItems.filter((item) => item.id !== id));
  };

  const handleCategoryChange = (categoryId: number) => {
    if (categoryIds.includes(categoryId)) {
      setCategoryIds(categoryIds.filter((id) => id !== categoryId));
      return;
    }
    setCategoryIds([...categoryIds, categoryId]);
  };

  const getPage = async (page: number) => {
    const response = await itemService.getPageAdmin({
      page,
      size: 1000,
      orderType: ItemAdminOrderType.ALL,
      itemType: ItemType.ITEM,
      categoryIds,
    });
    setItemPage(response.data);
  };

  // const getPage = async (name: string) => {
  //   try {
  //     const response = await itemService.getPageAdmin({
  //       page: itemPage.currentPage,
  //       size: PaginationSize.SIZE_12,
  //       orderType: orderType(),
  //       itemType: ItemType.PACKAGE,
  //       name,
  //       categoryIds: [1],
  //     });
  //     setItemPage(response.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    getPage(1);
  }, [categoryIds]);

  return (
    <Modal size="7xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>상품 추가하기</H4>
      </Modal.Header>
      <Modal.Body className="overflow-visible">
        <div className="flex gap-[16px] justify-center items-center">
          <div className="flex flex-col gap-[8px] w-[564px] h-[366px]">
            <div className="flex gap-[10px]">
              <ChildItemCategoryFilter
                categoryIds={categoryIds}
                handleCategoryChange={handleCategoryChange}
              />
            </div>
            <div className="overflow-scroll">
              <PackageItemChildSelectTable
                items={itemPage.contents.filter((item) => {
                  return !selectedItems.some((selectedItem) => {
                    return selectedItem.id === item.id;
                  });
                })}
                checkedItems={checkedItems}
                addItem={addCheckedItem}
                removeItem={removeCheckedItem}
              />
            </div>
          </div>
          {checkedItems.length > 0 ? (
            <BlackArrowNarrowRightlineIcon onClick={addSelectedItem} />
          ) : (
            <GrayArrowNarrowRightlineIcon />
          )}
          <div className="flex flex-col w-[564px] h-[366px] gap-[20px]">
            <div className="flex h-[24px] gap-[16px] ">
              <div>
                <div className="w-[199.5px] h-[12px] border-b"></div>
              </div>
              <div className="h-[24px]">
                <Body16Regular className="text-semantic-text-body">
                  패키지로 결합할 상품
                </Body16Regular>
              </div>
              <div>
                <div className="w-[199.5px] h-[12px] border-b"></div>
              </div>
            </div>
            <div className="overflow-scroll">
              <PackageItemChildSelectedTable
                items={selectedItems}
                removeItem={removeSelectedItem}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color={ButtonColor.PRIMARY}
          onClick={() => {
            setChildItems(selectedItems);
            closeModal();
          }}
        >
          추가하기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
